<template>
  <div class="content">
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 侧边树 -->
      <el-aside width="15%" style="height:100%" class="aside">
        <div style="height:100%;overflow-y: auto;padding: 1vh;">
          <el-tree
            :data="dataTree"
            class="join-tree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >  
            <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
              <span :title="node.label" class="">{{data.name}}</span>
            </span>
          </el-tree>
        </div>
      </el-aside>
      <el-main style="height: 100%;padding: 0px !important;position: relative;width: 84%;padding-left: 10px !important;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <p :style="{color:curColor}" style="border-left: 5px solid #0490F9;padding-left:1vw;display:flex;align-items: center;align-content: center;">{{pageTitle}}</p>
            <!-- <el-button type="primary" @click="exportFun">导出表格</el-button> -->
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="150" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="身份证号">
                <template slot-scope="scope">
                  <span>{{ scope.row.idcard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="安康码状态" width="200">
                <template slot-scope="scope">
                  <img :src="scope.row.codeImg" style="height:6vh;" />
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="personInfo(scope.$index, scope.row)">个人详情</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      //树形
      dataTree: [],
      defaultProps: {
        children: 'list',
        label: 'name'
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      search: {
        //查询
        projectId: '',
        healthLevel:'',
      },
      listData: [], //表格数据
      dataText: '数据加载中...',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      pageTitle:'',
      projectId:'',
      type:'',
      curColor:'#000000',
      groupId:''
    }
  },
  // created() {
  //   if(util.session.get('roleId')=='4'){
  //     this.projectId = util.session.get('groupId')
  //   }else{
  //     this.projectId = util.session.get('proId')
  //   }
  // },
  mounted() {
    // if(util.session.get('roleId')=='4'){
    //   this.projectId = util.session.get('groupId')
    // }else{
    //   this.projectId = util.session.get('proId')
    // }
    this.groupId = util.session.get('groupId')
    var params = this.$route.params
    if(params.type=='1'){
      this.pageTitle = '注册人数统计'
      this.curColor = '#597ef0'
    }else if(params.type=='2'){
      this.pageTitle = '核验人数统计'
      this.curColor = '#1d9de4'
    }else if(params.type=='3'){
      this.pageTitle = '正常绿码人数统计'
      this.curColor = '#0ccf93'
    }else if(params.type=='4'){
      this.pageTitle = '异常黄码人数统计'
      this.curColor = '#f8a62a'
    }else if(params.type=='5'){
      this.pageTitle = '异常红码人数统计'
      this.curColor = '#f9693b'
    }else if(params.type=='6'){
      this.pageTitle = '未核验人数统计'
      this.curColor = '#909399'
    }else if(params.type=='7'){
      this.pageTitle = '异常红码记录'
      this.curColor = '#f9693b'
    }
    this.type = params.type
    this.getAll()
    // this.getData()
  },
  methods: {
    //获取所有项目
    getAll() {
      var that = this
      myHttp
        .getPageListPro({
          entId: this.groupId,
          // joinType: this.joinType
        }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.entOfficeProjectMenu || []
            that.dataTree = list
            for(var i=0;i<list.length;i++){
                if (list[i].list.length > 0 && that.projectId=='') {
                  that.projectId= list[i].list[0].id
                  that.currentNodekey = list[i].list[0].id
                  that.expandedkeys.push(list[i].list[0].id)
                  that.$nextTick(() => {
                    // treeBox 元素的ref   value 绑定的node-key
                    that.$refs.tree.setCurrentKey(that.currentNodekey)
                  })
                  that.getData()
                }
                
            }
          }
         
        })
    },
    //点击树形结构
    handleNodeClick(data) {
      if(data.list){
       return
      }else{
        this.projectId=data.id
        this.getData()
      }
      
    },
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      this.search.healthLevel = this.type
      this.search.projectId = this.projectId
      myHttp.selectAnKangCodeByProjectId(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.PageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              if(list[i].healthLevel=='1'){
                  list[i].codeImg = require('../../../assets/image/anKang-gress.png')
              }else if(list[i].healthLevel=='2'){
                  list[i].codeImg = require('../../../assets/image/anKang-yellow.png')
              }else if(list[i].healthLevel=='3'){
                  list[i].codeImg = require('../../../assets/image/anKang-red.png')
              }else if(list[i].healthLevel=='4'||list[i].healthLevel=='0'){
                  list[i].codeImg = require('../../../assets/image/anKang-no.png')
              }
            }
            that.listData = list
            that.totalItems = resp.data.data.PageInfo.total || 0
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    exportWorker() {
      // var token = util.session.get('token')
      // window.open(
      //   myHttp.exportAttendList +
      //     '?projectId=' +
      //     this.search.projectId +
      //     '&personName=' +
      //     this.search.personName +
      //     '&date=' +
      //     this.search.date +
      //     '&accessToken=' +
      //     token
      // )
    },
    // watchInput(e) {
    //   this.search.personName = e
    //   this.getData()
    // }
    personInfo(index,row){
        // var port = util.session.get('roleId')
        // if(port=='4'){
        //     this.$router.push({name: 'workerInfo',params: { id: row.personId }})
        // }else if(port=='5'||port=='3'){
        //      this.$router.push({name: 'workerInfoCom',params: { id: row.personId }})
        //  }  
    
    },
    /**导出列表 */
    exportFun(){
      var token = util.session.get('token')
      window.open(myHttp.exportAnKangCode+'?projectId='+this.projectId+'&healthLevel='+this.type+'&accessToken='+token)
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
    
  }
}
</script>
<style>
@import '../../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 1.2vw;
  height: 30px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0 1vw;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-input-group--append .el-input__inner{
      width: 200px;
    }
</style>